import { zodResolver } from '@hookform/resolvers/zod';

import {
  CollectPaymentForm as CollectPaymentFormType,
  collectPaymentFormSchema,
} from '@shared/types';

import { useForm } from 'react-hook-form';
import { CollectPublicPaymentForm } from '../components';

import { trpc } from '@web/lib/trpc';
import { env } from '@web/utils';
import { z } from 'zod';

import { toast } from 'sonner';

import { PublicPaymentRoute } from '@web/routes/pay';
import { Dialog, DialogContent } from '@web/components/ui/dialog';

async function create({ authToken }: { authToken: string }) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/x-www-form-urlencoded');

  const urlencoded = new URLSearchParams();
  urlencoded.append('tokenizationKey', authToken);

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: urlencoded,
  };

  const res = await fetch(
    'https://secure.nmi.com/token/api/create',
    requestOptions,
  ).then((response) => response.text());

  const token = z.object({ token: z.string() }).safeParse(JSON.parse(res))
    .data?.token;

  return token;
}

async function register({
  authToken,
  gatewayPaymentToken,
  card: { number, exp, cvv },
}: {
  authToken: string;
  gatewayPaymentToken: string;
  card: { number: string; exp: string; cvv: string };
}) {
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');

  const raw = JSON.stringify({
    tokenizationKey: authToken,
    cartCorrelationId: '',
    tokenId: gatewayPaymentToken,

    data: [
      {
        elementId: 'ccnumber',
        value: number.replaceAll(/[\s]+/g, ''),
      },
      {
        elementId: 'ccexp',
        value: exp.replaceAll(/[/\s]+/g, ''),
      },
      {
        elementId: 'cvv',
        cvvDisplay: false,
        value: cvv,
      },
    ],
  });

  const requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
  };

  const res = await fetch(
    'https://secure.nmi.com/token/api/save_multipart_token',
    requestOptions,
  ).then((response) => response.text());

  const obj = JSON.parse(res) as unknown;

  return obj;
}

export function PublicPaymentView({
  internalPaymentToken,
  defaultValues,
}: {
  internalPaymentToken: string;
  defaultValues: CollectPaymentFormType;
}) {
  const Route = PublicPaymentRoute;

  const navigate = Route.useNavigate();

  const { mutateAsync: collectAsync } =
    trpc.payment.collectPublic.useMutation();

  const form = useForm<CollectPaymentFormType>({
    resolver: zodResolver(collectPaymentFormSchema),
    defaultValues,
  });

  const handleSubmit = async (values: CollectPaymentFormType) => {
    console.log(values);

    const { card, billing, payment } = values;

    const authToken = env.VITE_NMI_PUBLIC_KEY;
    if (!authToken) return;

    const gatewayPaymentToken = await create({ authToken });
    console.log('-->   ~ handleSubmit ~ paymentToken:', gatewayPaymentToken);
    if (!gatewayPaymentToken) return;

    const registration = await register({
      authToken,
      gatewayPaymentToken,
      card,
    });
    console.log('-->   ~ handleSubmit ~ registration:', registration);

    const paymentResult = await collectAsync({
      internalPaymentToken,
      gatewayPaymentToken,
      billing,
      payment,
    });

    console.log('-->   ~ handleSubmit ~ paymentResult:', paymentResult);

    // Get the current URL
    if (paymentResult?.status === 'success') {
      // Redirect to the success page
      console.log('Payment Success');

      toast.success('Payment successfull');

      void navigate({
        to: '/payment-success',
        search: { token: internalPaymentToken },
      });
    } else {
      console.log('Payment Failed');

      toast.error('Payment failed', { description: 'Please try again.' });
    }
  };

  return (
    <Dialog open={true}>
      <DialogContent className="z-50 mx-auto h-[98dvh] max-w-3xl overflow-auto overflow-y-auto rounded-lg bg-white p-6 shadow-lg">
        <CollectPublicPaymentForm form={form} onSubmit={handleSubmit} />
      </DialogContent>
    </Dialog>
  );
}
